/** 星闪 DK75 系列 keyboardType（Pro / E / 标准款各用各的） */
export const DK75_FAMILY_KEYBOARD_TYPES = ["dk75Pro", "dk75E", "dk75"] as const;

export type Dk75FamilyKeyboardType =
  (typeof DK75_FAMILY_KEYBOARD_TYPES)[number];

export function isDk75FamilyKeyboardType(
  keyboardType?: string | null
): keyboardType is Dk75FamilyKeyboardType {
  const kt = String(keyboardType ?? "");
  return kt === "dk75Pro" || kt === "dk75E" || kt === "dk75";
}

/** F 行末为小屏+旋钮占位（仅 DK75 Pro / ZE75） */
export function isDk75ProLikeKeyboardType(
  keyboardType?: string | null
): boolean {
  return String(keyboardType ?? "") === "dk75Pro";
}

/** F 行末为 PrtScr 实键 + 旋钮占位（DK75 标准款） */
export function isDk75StandardKeyboardType(
  keyboardType?: string | null
): keyboardType is "dk75" {
  return String(keyboardType ?? "") === "dk75";
}
